import { Translation } from 'hooks/useTranslation/useTranslation';
import { FilterChip } from 'v2/components/SearchAndFilters/SearchAndFilters';
import { AccessCardsFilterState, FilterAssignedState, FilterStatusState } from './cardFilterTypes';

interface Params {
  translation: Translation;
  filters: AccessCardsFilterState;
}

export const createCardFilterChips = ({ translation, filters }: Params): FilterChip[] => {
  const { filterStatus, filterValidity, filterAssigned } = filters.filter;
  const { setFilterStatus, setFilterValidity, setFilterAssigned } = filters.setters;

  const statusLabels: Record<keyof FilterStatusState, string> = {
    cardBlocked: translation.card_blocked,
    userDeleted: translation.user_deleted,
    cardExpired: translation.card_expired,
    accessRightsChanged: translation.access_rights_changed,
    userExpiresSoon: translation.user_expires_soon
  };

  return [
    ...(Object.keys(filterStatus) as (keyof FilterStatusState)[])
      .filter((key) => filterStatus[key])
      .map((key) => ({
        label: statusLabels[key],
        onDelete: () => setFilterStatus((current) => ({ ...current, [key]: false }))
      })),
    ...(filterValidity !== null
      ? [
          {
            label: `${translation.card_validity_expires_in}: ${translation[filterValidity]}`,
            onDelete: () => setFilterValidity(null)
          }
        ]
      : []),
    ...(filterAssigned !== null
      ? [
          {
            label: filterAssigned === FilterAssignedState.Assigned ? translation.assigned : translation.unassigned,
            onDelete: () => setFilterAssigned(null)
          }
        ]
      : [])
  ];
};
